module.exports = __webpack_public_path__ + "static/media/feed_the_ward_map.8eb66cf3.svg";